<template>
  <div class="mc-qual">
    <div class="mc-qual__top">
      <div class="mc-qual__ico">
        <feather-icon
          icon="AwardIcon"
          size="20"
        />
      </div>
      <h3 class="mc-qual__title">
        Qualidade do Bot
      </h3>
    </div>

    <div class="mc-qual__csat-block">
      <div class="mc-qual__score-row">
        <span class="mc-qual__score">{{ csatDisplay }}</span>
        <div
          class="mc-qual__stars"
          aria-hidden="true"
        >
          <span
            v-for="n in 5"
            :key="n"
            class="mc-qual__star"
            :class="{ 'mc-qual__star--on': n <= fullStars }"
          >★</span>
        </div>
      </div>
      <span class="mc-qual__csat-label">CSAT</span>
    </div>

    <div class="mc-qual__faces">
      <span
        v-for="(f, i) in faces"
        :key="i"
        class="mc-qual__face"
        :class="{ 'mc-qual__face--active': i === activeFace }"
      >{{ f }}</span>
    </div>

    <div class="mc-qual__bar-block">
      <div class="mc-qual__bar-head">
        <span>Sem transferência</span>
        <strong>{{ pctSemTransferencia }}%</strong>
      </div>
      <div class="mc-qual__track">
        <div
          class="mc-qual__fill"
          :style="{ width: `${Math.min(100, Math.max(0, pctSemTransferencia))}%` }"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QualidadeBot',
  props: {
    csat: {
      type: [Number, String],
      default: 0,
    },
    pctSemTransferencia: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      faces: ['😟', '😐', '🙂', '😊', '😄'],
    }
  },
  computed: {
    csatNum() {
      const n = Number(this.csat)
      return Number.isFinite(n) ? n : 0
    },
    csatDisplay() {
      return Number.isFinite(Number(this.csat)) ? Number(this.csat).toFixed(1) : '—'
    },
    fullStars() {
      if (!Number.isFinite(this.csatNum) || this.csatNum <= 0) return 0
      return Math.min(5, Math.round(this.csatNum))
    },
    activeFace() {
      const idx = Math.round(this.csatNum) - 1
      return Math.max(0, Math.min(4, idx))
    },
  },
}
</script>

<style scoped>
.mc-qual {
  background: var(--mc-surface);
  border-radius: var(--mc-radius-lg);
  border: 1px solid var(--mc-border);
  box-shadow: var(--mc-shadow-md);
  padding: 1.35rem 1.4rem;
  margin-bottom: 1.25rem;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.mc-qual:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 34px rgba(93, 42, 140, 0.1);
}

.mc-qual__top {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 1.15rem;
}

.mc-qual__ico {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(123, 63, 228, 0.12) 0%, rgba(122, 167, 255, 0.12) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--mc-purple) !important;
}

.mc-qual__title {
  font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--mc-text);
  margin: 0;
}

.mc-qual__csat-block {
  margin-bottom: 0.85rem;
}

.mc-qual__score-row {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.mc-qual__score {
  font-size: 1.75rem;
  font-weight: 800;
  color: var(--mc-text);
}

.mc-qual__stars {
  display: flex;
  gap: 0.12rem;
  font-size: 1.1rem;
  line-height: 1;
}

.mc-qual__star {
  color: var(--mc-border);
}

.mc-qual__star--on {
  color: #f0b429;
}

.mc-qual__csat-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--mc-text-muted);
}

.mc-qual__faces {
  display: flex;
  justify-content: space-between;
  gap: 0.25rem;
  margin-bottom: 1.1rem;
  padding: 0.4rem 0;
  border-bottom: 1px solid var(--mc-border);
}

.mc-qual__face {
  font-size: 1.25rem;
  opacity: 0.35;
  filter: grayscale(0.5);
  transition: opacity 0.2s, transform 0.2s;
}

.mc-qual__face--active {
  opacity: 1;
  filter: none;
  transform: scale(1.12);
}

.mc-qual__bar-head {
  display: flex;
  justify-content: space-between;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--mc-text-soft);
  margin-bottom: 0.35rem;
}

.mc-qual__bar-head strong {
  color: var(--mc-text);
}

.mc-qual__track {
  height: 8px;
  border-radius: var(--mc-radius-pill);
  background: var(--mc-lilac-soft, #ede4f7);
  overflow: hidden;
}

.mc-qual__fill {
  height: 100%;
  border-radius: var(--mc-radius-pill);
  background: linear-gradient(90deg, var(--mc-purple) 0%, var(--mc-pink) 100%);
  transition: width 0.45s ease;
}
</style>
